const validateHasTooManyImages = (allMedia: any[]) => {
    if (allMedia.length > 30) {
        throw new Error('tooMany');
    }
};
export { validateHasTooManyImages };
